var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AfterViewInit, ElementRef, QueryList, Renderer2 } from '@angular/core';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/takeUntil';
import 'rxjs/add/operator/combineLatest';
import { MatIcon } from '@angular/material';
import { bindFunctionsToThis } from '../../../extensions';
import { BaseComponent } from '../../base.component';
var ActionsComponent = /** @class */ (function (_super) {
    __extends(ActionsComponent, _super);
    function ActionsComponent(renderer) {
        var _this = _super.call(this) || this;
        _this.renderer = renderer;
        _this.animationDelay = 100;
        _this.animationGap = 25;
        bindFunctionsToThis(_this);
        return _this;
    }
    ActionsComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.matIcons
            .changes
            .startWith(this.matIcons.toArray())
            .takeUntil(this.isDestroyed)
            .subscribe(function () {
            var icons = Array.from(_this.iconButtons.nativeElement.querySelectorAll('mat-icon'));
            icons.forEach(function (icon, index) {
                icon.style.transitionDelay = _this.animationDelay + (index + 1) * _this.animationGap + "ms";
            });
        });
    };
    ActionsComponent.prototype.show = function () {
        if (this.showTriggerTimeout) {
            clearTimeout(this.showTriggerTimeout);
        }
        this.isShowing = true;
        this.renderer.setStyle(this.trigger.nativeElement, 'opacity', '0');
    };
    ActionsComponent.prototype.hide = function () {
        var _this = this;
        this.isShowing = false;
        var icons = Array.from(this.iconButtons.nativeElement.querySelectorAll('mat-icon'));
        var allIconsHideAnimationTiming = icons.length * 25 + 250;
        this.showTriggerTimeout = setTimeout(function () {
            _this.renderer.setStyle(_this.trigger.nativeElement, 'opacity', '1');
        }, allIconsHideAnimationTiming);
    };
    return ActionsComponent;
}(BaseComponent));
export { ActionsComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/row.action.buttons/actions/actions.component.ts.pre-build-optimizer.js